import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { mdiCheckCircleOutline } from '@mdi/js'
import IntlFormattedDate from 'app/i18n/IntlFormattedDate'
import getDeclensionLabel from 'app/utils/getDeclensionLabel'
import { commonMessages } from 'app/i18n/messages'
import { useAppSelector } from 'app/hooks'
import {
  claimDevicesFetchDataSelector,
  subsribedAccessPointsCountSelector,
} from 'features/networkAi/selectors'
import theme from 'theme_'

import SubscriptionStatusDashboard from '../../SubscriptionStatusDashboard'
import { PurchaseSubscriptionBlock } from '../styles'
import PurchaseState from '../PurchaseState'

interface PurchaseStateSuccessProps {
  nextBillingDate: number
  accessPointsCount: number
  accessPointsRenewCount: number
  jobName: string
}

function PurchaseStateSuccess({
  nextBillingDate,
  accessPointsCount,
  accessPointsRenewCount,
  jobName,
}: PurchaseStateSuccessProps) {
  const { formatMessage } = useIntl()

  const claimDevices = useAppSelector(claimDevicesFetchDataSelector.data)
  const subscribedCount = useAppSelector(subsribedAccessPointsCountSelector)

  const pointLabel = useMemo(() => {
    return getDeclensionLabel(accessPointsCount, 'point')
  }, [accessPointsCount])

  return (
    <>
      <PurchaseSubscriptionBlock>
        <SubscriptionStatusDashboard
          subscribedCount={subscribedCount}
          claimedCount={claimDevices?.length || 0}
        />
      </PurchaseSubscriptionBlock>
      <PurchaseState
        icon={mdiCheckCircleOutline}
        iconColor={theme.colors.successGreen}
        title={formatMessage(commonMessages.success)}
      >
        <div>
          You currently have{' '}
          <b>
            {accessPointsCount} Access {pointLabel} subscriptions
          </b>{' '}
          for home <b>{jobName}</b>.
        </div>
        {accessPointsRenewCount ? (
          <div>
            The renewal date will be{' '}
            <b>
              <IntlFormattedDate date={nextBillingDate} />.
            </b>
          </div>
        ) : (
          <div>
            There are no renewals scheduled, Smart Network service will stop on{' '}
            <b>
              <IntlFormattedDate date={nextBillingDate} />.
            </b>
          </div>
        )}
      </PurchaseState>
    </>
  )
}

export default PurchaseStateSuccess
